import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { IAuthSlice, createAuthSlice } from './slices/createAuthSlice'
import { IUserSlice, createUserSlice } from './slices/createUserSlice'

export const useSession = create<
  IUserSlice & IAuthSlice & { isHydrated: boolean },
  [['zustand/persist', unknown]]
>(
  persist(
    (...a) => ({
      ...createAuthSlice(...a),
      ...createUserSlice(...a),
      isHydrated: false,
    }),
    {
      name: '@cockpitia-session',
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.isHydrated = true
        }
      },
    },
  ),
)
